import React from 'react';

import styles from './tiledSectionHeader.module.scss';
import ContentList from './ContentList';
import SubscribeToPower from './SubscribeToPower';

const TiledSectionHeader = () => {
    return (
        <div className={`${styles.section}`}>
            <div className={`container ${styles.container}`}>
                <div className="row">
                    <ContentList
                        title="JUNIOR PLAYERS"
                    >
                        <li>Guaranteed 4 competitive matches each month</li>
                        <li>Meet new opponents & hitting partners at your level</li>
                        <li>Improve your UTR, which college coaches use to evaluate players</li>
                        <li>“Match tough” prep for tournament readiness</li>
                    </ContentList>
                    <ContentList
                        title="ADULT PLAYERS"
                    >
                        <li>Guaranteed 4 matches each month at your level</li>
                        <li>Self-organize matches to work with your busy schedule</li>
                        <li>1:1 matchplay in a socially distanced environment</li>
                        <li>All the fun of league play without politics</li>
                    </ContentList>
                </div>
                <SubscribeToPower
                    powerInfo="Singles: Just $25 for Power Subscribers, $35 for non-Power Subscribers"
                />
                <SubscribeToPower
                    powerInfo="Doubles: Just $40 for Power Subscribers, $50 for non-Power Subscribers (Team price)"
                />
            </div>
        </div>
    );
};

export default TiledSectionHeader;
